import firebase from './firebase';

// Labels are free text ("Hund/Katze", "z.B.") that a dotted path rejects or
// splits, and a patch object cannot carry a FieldPath, so they get their own update().
export const customDataWrites = (customData?: Record<string, any> | null) => {
  const patch: Record<string, any> = {};
  const literal: any[] = [];
  Object.entries(customData ?? {}).forEach(([key, value]) => {
    if (/[.~*/[\]]/.test(key))
      literal.push(new firebase.firestore.FieldPath('customData', key), value ?? '');
    else patch['customData.' + key] = value ?? '';
  });
  return { patch, literal };
};
